var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pts-done"},[_vm._m(0),_c('p',{staticClass:"pts-done__body"},[(_vm.final)?[_vm._v("Thank you for your feedback")]:[_vm._v("Feedback for "),_c('strong',[_vm._v(_vm._s(_vm.sectionTitle))]),_vm._v(" complete - please press \"Continue\"")]],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pts-done__icon"},[_c('i',{staticClass:"material-icons"},[_vm._v("check_circle")])])
}]

export { render, staticRenderFns }